/*
 * @Author: wangyunwon
 * @Date: 2025-09-09 11:27:08
 * @Description: 商家异常位置上报相关接口声明
 */
import { request } from '@/common/utils/request'

/**
 * 获取位置异常页商家相关信息
 * mock地址：https://mock.xiaojukeji.com/project/12854/interface/api/1112719
 */
export function fetchShopInfoApi(params) {
  return request.get({
    url: 'feidian.bdapp.poiErrorReportingInit',
    params,
  })
}

// 异常上报信息提交
export function saveReportInfoApi(data) {
  return request.post({
    url: 'feidian.bdapp.poiErrorReportingSubmit',
    data,
  })
}

export function fetchPoiListByText(data) {
  return request.post({
    url: 'crm.common.textSearchGateway',
    data,
  })
}
